'use strict';

function renderTasks (mustache, $marketingChecklist, tasks) {
  var tasksHtml = window.Mustache.render(
    mustache,
    {
      tasksList: tasks,
      domain: window.currentWebsite,
      reportUrl: encodeURIComponent(window.location.href)
    }
  );

  $marketingChecklist.find('.marketing-checklist-list').html(tasksHtml);
}

module.exports = renderTasks;
